module.exports = __webpack_public_path__ + "img/281.1c4c5376.png";